// ==========================================
// Store pour la liaison des comptes multi-jeux
// ==========================================

import { create } from 'zustand';

interface LinkedGame {
  gameId: string;
  gameName: string;
  gameUrl: string;
  userId: string | number;
  userPseudo: string;
  level: number;
  totalPoints: number;
}

interface LinkAccountsState {
  showModal: boolean;
  linkedGames: LinkedGame[];
  benefits: string[];
  hasChecked: boolean;
  
  // Actions
  checkLinkedAccounts: (email: string) => Promise<void>;
  linkAccount: (gameId: string, token: string) => Promise<boolean>;
  openModal: () => void;
  closeModal: () => void;
  reset: () => void;
}

const API_URL = '/api';

export const useLinkAccountsStore = create<LinkAccountsState>((set, get) => ({
  showModal: false,
  linkedGames: [],
  benefits: [],
  hasChecked: false,
  
  checkLinkedAccounts: async (email: string) => {
    if (get().hasChecked) return;
    
    try {
      const res = await fetch(`${API_URL}/auth/check-linked-accounts?email=${encodeURIComponent(email)}`);
      const data = await res.json();
      
      if (data.success && data.hasLinkedAccounts) {
        set({
          linkedGames: data.linkedGames,
          benefits: data.benefits,
          showModal: true,
          hasChecked: true,
        });
      } else {
        set({ hasChecked: true });
      }
    } catch (error) {
      console.error('Erreur vérification comptes liés:', error);
      set({ hasChecked: true });
    }
  },
  
  linkAccount: async (gameId: string, token: string) => {
    try {
      const res = await fetch(`${API_URL}/auth/link-account`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ targetGameId: gameId }),
      });
      
      const data = await res.json();
      return data.success === true;
    } catch (error) {
      console.error('Erreur liaison compte:', error);
      return false;
    }
  },
  
  openModal: () => set({ showModal: true }),
  
  closeModal: () => set({ showModal: false }),
  
  reset: () => set({
    showModal: false,
    linkedGames: [],
    benefits: [],
    hasChecked: false,
  }),
}));
